import React, { useState } from 'react';
import Modal from './Modal';
import VideoTaskModalContent from './VideoTaskModalContent';
import SuccessModalContent from './SuccessModalContent';
import queryString from 'query-string';
import axios from 'axios';

function ShareAndEarn() {
  const [isVideoModalOpen, setVideoModalOpen] = useState(true);
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState(''); // ✅ Define state
  const [formData, setFormData] = useState({
    userid: '',
    appname: '',
  });

  React.useEffect(() => {
    // Simulate fetching user data from localStorage or an API
    const userid = queryString.parse(window.location.search).userid || '';
    const appname = queryString.parse(window.location.search).appname || '';
    setFormData({ userid, appname });
  }, []);
  const onClose = () => {
    if (!videoUrl) {
      alert('Missing URL');
    } else if (!videoUrl.startsWith('https://')) {
      alert('Please read the description carefully before sumbit.');
    } else if (/app-earning|giveaway/i.test(videoUrl)) {
      alert('Please read the description carefully before sumbit.');
    } else {
      axios.post(`https://givvy-backend-site.herokuapp.com/registerWithdrawVideo`, {
        userId: formData.userid,
        appName: formData.appname,
        videoUrl: videoUrl
      }).then((response) => {
        console.log("Response from registerWithdrawVideo:", response.data);
        if (response.data.video && response.data.video.isPending) {
          setVideoModalOpen(false);
          setSuccessModalOpen(true);
          console.log("Video task registered successfully");
        } else {
          alert(response.data.message);
        }
      }).catch((error) => {
        console.error("Error registering video task:", error);
      });
    }
  };

  return (
    <div className="App">
      {/* <button onClick={() => setModalOpen(true)}>Open Modal</button> */}

      <Modal isOpen={isVideoModalOpen} >
        <VideoTaskModalContent data={formData} onClose={() => { onClose() }} changeUrl={(video) => { setVideoUrl(video) }}></VideoTaskModalContent>
      </Modal>
      <Modal isOpen={isSuccessModalOpen} onClose={() => setSuccessModalOpen(false)}>
        <SuccessModalContent></SuccessModalContent>
      </Modal>
    </div>
  );
}

export default ShareAndEarn;
